import { ReactNode } from 'react';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  breadcrumbs?: ReactNode;
}

export default function PageHeader({ action, breadcrumbs }: PageHeaderProps) {
  if (!action && !breadcrumbs) return null;

  return (
    <div className="mb-4">
      {breadcrumbs && <div className="mb-2">{breadcrumbs}</div>}
      {action && <div className="flex justify-end">{action}</div>}
    </div>
  );
}
